import type { Ref } from 'react';
import { forwardRef } from 'react';

import type { TIconSize } from '../../icon.interface';
const BillingPaymentGenericError = forwardRef(
  ({ ...props }: TIconSize, ref: Ref<SVGSVGElement>) => {
    return (
      <svg
        width="174"
        height="192"
        viewBox="0 0 174 192"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={ref}
        {...props}
      >
        <g clipPath="url(#clip0_1901_26144)">
          <path
            d="M165.965 40.2559C176.319 52.4919 175.143 74.3771 170.906 91.9341C166.622 109.535 159.233 122.861 148.88 138.772C138.526 154.682 125.218 173.214 107.605 177.498C89.9919 181.782 68.1627 171.77 48.9617 155.86C29.7606 139.95 13.1434 118.053 8.72103 91.7927C4.30157 65.4822 12.015 34.7492 31.219 22.5132C50.423 10.2772 81.153 16.5352 107.464 20.9605C133.724 25.4301 155.609 28.0199 165.965 40.2559Z"
            fill="#F2F7FF"
          />
          <path
            d="M83.8337 59.4243C83.433 61.3835 83.8691 75.4109 83.2886 77.6236C82.7082 79.8363 76.2676 106.877 76.2676 106.877L86.5119 104.046C86.5119 104.046 90.1034 96.1529 91.4057 89.0464C92.5518 82.7914 92.3868 59.5333 83.8337 59.4243Z"
            fill="#DB9D76"
          />
          <path
            d="M73.891 65.6176H67.2441L63.4375 51.1807H70.0873L73.891 65.6176Z"
            fill="#1A1A1A"
          />
          <path
            d="M159.969 105.761H87.752V177.978H159.969V105.761Z"
            fill="#D2D2D2"
          />
          <path
            d="M101.127 127.449C105.146 127.449 108.404 124.19 108.404 120.171C108.404 116.152 105.146 112.894 101.127 112.894C97.1078 112.894 93.8496 116.152 93.8496 120.171C93.8496 124.19 97.1078 127.449 101.127 127.449Z"
            fill="#818180"
          />
          <path
            d="M114.52 117.051H151.416"
            stroke="white"
            strokeWidth="0.567407"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M114.52 123.288H130.877"
            stroke="white"
            strokeWidth="0.567407"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M114.52 138.751H151.416"
            stroke="white"
            strokeWidth="0.567407"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M114.52 144.988H130.877"
            stroke="white"
            strokeWidth="0.567407"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M114.52 160.448H151.416"
            stroke="white"
            strokeWidth="0.567407"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M114.52 166.685H130.877"
            stroke="white"
            strokeWidth="0.567407"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M101.127 149.146C105.146 149.146 108.404 145.888 108.404 141.868C108.404 137.849 105.146 134.591 101.127 134.591C97.1078 134.591 93.8496 137.849 93.8496 141.868C93.8496 145.888 97.1078 149.146 101.127 149.146Z"
            fill="white"
          />
          <path
            d="M101.127 170.845C105.146 170.845 108.404 167.587 108.404 163.567C108.404 159.548 105.146 156.29 101.127 156.29C97.1078 156.29 93.8496 159.548 93.8496 163.567C93.8496 167.587 97.1078 170.845 101.127 170.845Z"
            fill="white"
          />
          <path
            d="M18.8066 173.703L25.5979 169.793L29.8936 177.66L21.9828 181.567L18.8066 173.703Z"
            fill="#FFB688"
          />
          <path
            d="M68.6309 169.793L70.1453 178.488L79.3289 176.926L76.3001 167.059L68.6309 169.793Z"
            fill="#FFB688"
          />
          <path
            d="M91.3584 100.544C88.6537 100.691 44.2735 110.328 43.696 112.588C38.9437 131.126 66.088 170.041 68.0826 171.22C70.2334 170.701 77.5727 168.144 77.5727 168.144L75.8874 142.196L91.3584 100.544Z"
            fill="#0057CB"
          />
          <path
            d="M23.9829 182.787L18.5617 171.455L3.80957 157.34L0 159.437L14.6048 187.427L23.9829 182.787Z"
            fill="#1A1A1A"
          />
          <path
            d="M80.0242 174.843L67.6556 177.047L50.1133 187.498L51.1239 191.731L81.9952 185.12L80.0242 174.843Z"
            fill="#1A1A1A"
          />
          <path
            d="M125.595 89.0469C127.322 90.4288 129.131 96.6572 129.34 98.7697C131.6 123.277 91.2621 137.708 85.6759 140.13C80.3725 144.564 34.1155 178.665 31.2959 179.472C28.4763 180.279 23.8653 169.455 24.269 168.008C24.6726 166.561 92.4701 98.4073 92.4701 98.4073L125.595 89.0469Z"
            fill="#006DFF"
          />
          <path
            d="M93.1593 44.932C87.4523 42.1124 82.1754 57.5776 82.6822 59.3483C83.189 61.119 88.4275 61.6258 89.7533 61.6258C91.0792 61.6258 93.1593 44.932 93.1593 44.932Z"
            fill="#00355B"
          />
          <path
            d="M104.102 36.0601C124.933 36.0601 126.898 85.7201 126.662 89.1084C124.559 96.0145 99.3264 104.311 91.5599 99.771C79.2355 70.8737 84.913 36.0601 104.102 36.0601Z"
            fill="#00355B"
          />
          <path
            d="M124.882 60.5441C126.046 62.5299 128.55 75.4701 128.3 77.1583C128.05 78.8465 124.175 83.1069 122.796 83.2012C103.192 84.5329 81.9281 76.6987 77.9535 74.4978C69.6391 73.8349 64.7188 70.8326 64.7188 66.4426C64.7188 63.8498 66.1565 61.9819 66.9491 61.9819C68.4517 61.9819 71.1211 64.5717 71.4452 65.3289C70.797 63.9971 68.764 61.5517 70.4375 61.5517C70.903 61.5517 74.6802 66.8315 76.7308 68.1131C78.7815 69.3948 108.377 70.4702 114.311 72.6269C113.554 71.1184 111.432 65.65 111.397 64.8604C111.362 64.0708 124.882 60.5441 124.882 60.5441Z"
            fill="#FFB688"
          />
          <path
            d="M110.092 40.0169C119.111 36.7112 126.241 57.5475 125.949 60.1873C125.658 62.8272 111.218 67.45 109.591 66.4954C107.965 65.5408 101.153 43.2932 110.092 40.0169Z"
            fill="#00355B"
          />
          <path
            d="M104.691 27.0235C104.594 28.2757 105.357 35.2732 106.55 37.5565C106.023 38.5936 100.601 41.6077 98.0058 40.9625C97.6522 39.0238 96.7123 33.8177 95.9434 32.2326C97.3311 31.5078 104.691 27.0235 104.691 27.0235Z"
            fill="#DB9D76"
          />
          <path
            d="M98.0299 33.0985C104.343 31.4235 107.759 23.6511 105.659 15.7384C103.56 7.82578 96.7402 2.76922 90.427 4.4443C84.1139 6.11938 80.6981 13.8918 82.7975 21.8044C84.897 29.7171 91.7168 34.7736 98.0299 33.0985Z"
            fill="#FFB688"
          />
          <path
            d="M99.7836 18.5768C99.1296 18.6122 96.634 17.3394 96.0801 13.521C94.2799 13.2263 86.3426 14.0719 82.1824 17.3512C80.6415 17.9404 79.3923 18.4325 77.0617 18.4325C75.9569 18.4325 75.0199 17.2775 75.0199 16.4849C75.0199 14.3017 75.9569 12.1863 78.694 12.0449C76.39 11.9948 74.2539 10.5717 74.2539 9.52283C74.2539 8.12922 77.4212 3.85413 82.9455 5.72798C81.6491 4.79106 80.1848 3.8777 80.1848 2.99087C80.1848 1.47352 82.368 0.000366211 86.1864 0.000366211C92.0938 0.000366211 98.5315 2.44875 99.9221 4.2018C100.57 3.86592 101.395 3.2413 102.974 3.2413C106.911 3.2413 108.231 15.9929 106.528 20.268C106.106 20.5389 105.634 20.7223 105.14 20.8072"
            fill="#1A1A1A"
          />
          <path
            d="M99.6641 18.8569C99.8594 18.3009 100.219 17.8174 100.695 17.4704C101.172 17.1234 101.742 16.9293 102.331 16.9138C102.92 16.8984 103.5 17.0622 103.994 17.3837C104.488 17.7053 104.873 18.1692 105.097 18.7142C105.321 19.2591 105.375 19.8594 105.25 20.4354C105.125 21.0114 104.829 21.5359 104.399 21.9396C103.97 22.3432 103.428 22.6069 102.846 22.6957C102.263 22.7844 101.667 22.6941 101.137 22.4367"
            fill="#FFB688"
          />
        </g>
        <rect
          x="52.5"
          y="34.6699"
          width="18"
          height="16"
          rx="2"
          transform="rotate(-18.3607 52.5 34.6699)"
          fill="#FFE8EB"
        />
        <path
          d="M67.0276 49.8677L64.4387 47.566L67.7265 46.4748L67.0276 49.8677Z"
          fill="#FFE8EB"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M58.754 36.8648C58.9239 36.5262 59.3362 36.3893 59.6749 36.5592L63.6869 38.5718L65.6995 34.5597C65.8694 34.221 66.2816 34.0842 66.6203 34.2541C66.959 34.4239 67.0958 34.8362 66.926 35.1749L64.9134 39.187L68.9255 41.1995C69.2642 41.3694 69.401 41.7817 69.2311 42.1204C69.0612 42.459 68.649 42.5959 68.3103 42.426L64.2982 40.4135L62.2856 44.4255C62.1158 44.7642 61.7035 44.901 61.3648 44.7312C61.0261 44.5613 60.8893 44.149 61.0592 43.8103L63.0717 39.7982L59.0596 37.7857C58.721 37.6158 58.5841 37.2035 58.754 36.8648Z"
          fill="#D20000"
        />
        <defs>
          <clipPath id="clip0_1901_26144">
            <rect width="174" height="191.731" fill="white" />
          </clipPath>
        </defs>
      </svg>
    );
  }
);
export default BillingPaymentGenericError;
